import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuditHistoryService } from '../../../../../../../core/services/audit-history.service';
import { archiveAuditType, archiveDBKeys } from '../../../../utils';

@Component({
  selector: 'app-order-list-audit',
  templateUrl: './order-list-audit.component.html',
  styleUrls: ['./order-list-audit.component.scss']
})
export class OrderListAuditComponent implements OnInit {

  auditLoader = true;
  auditLogData: any = [];
  archiveDBKeys = archiveDBKeys;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<OrderListAuditComponent>,
    public auditHistoryService: AuditHistoryService,
  ) { }

  ngOnInit() {
    this.fetchAuditLogs();
  }

  fetchAuditLogs() {
    this.auditHistoryService.fetchLogs(archiveAuditType).then((auditLogRes: any) => {

      this.auditHistoryService.formatAuditLogData(auditLogRes).then((formatRes: any) => {
        this.auditLogData = [...formatRes];
        this.auditLoader = false;
      })

    }).catch((auditLogErr) => {
      this.auditLoader = false;
    });
  }


}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/order-list-audit/order-list-audit.component.ts